<template lang="pug">
  .v-card--plan.mx-auto.pt-0.pb-4.px-0.text-center(:color="!plan.best ? 'elevation-4' : undefined" :light="plan.best" max-width="100%").plan--card
    img(:src="startupbg" v-if="plan.title === 'REACTIVATE'").plan--card__container
    img(:src="businessbg" v-else-if="plan.title === 'BUSINESS'").plan--card__container
    img(:src="enterprisebg" v-else-if="plan.title === 'ENTERPRISE'").plan--card__container
    img(:src="corporatebg" v-else).plan--card__container
    .plan--card__heading {{plan.heading}}
    i(v-if="plan.title === 'REACTIVATE'" class="plan--card__avatar__startup").plan--card__avatar
      img(:src="startup").plan--card__avatar__img
    i(v-else-if="plan.title === 'BUSINESS'" class="plan--card__avatar__startup").plan--card__avatar
      img(:src="business").plan--card__avatar__img
    i(v-else-if="plan.title === 'ENTERPRISE'" class="plan--card__avatar__enterprise").plan--card__avatar
      img(:src="enterprise").plan--card__avatar__img
    i(v-else class="plan--card__avatar__corporate").plan--card__avatar
      img(:src="corporate").plan--card__avatar__img
    span.plan--card__cost {{plan.cost | numberFormat}} {{currency}}
    span(v-if="getCurrencyValue(plan.cost)").plan--card__cost.plan--card__cost--aprox Aproximadamente {{getCurrencyValue(plan.cost) | numberFormat}} {{getCurrencyName()}}
    h2.plan--card__subtitle {{plan.subtitle}}
    // h2.plan--card__subtitle {{plan.subtitlePrice}}
    span.plan--card__description {{plan.text}}
    v-list-item(v-for="(item, index) in plan.itemList" :key="index")
      v-list-item-content
        v-list-item-title.plan--card__description {{ item.text }}
    v-btn(large @click="queuePlan(plan)").plan--card__btn.pa-4
      | {{ $t('plan') }}

</template>

<script>
  import axios from 'axios'
  import startup from '@/assets/icons/plans/startup-icon.png'
  import business from '@/assets/icons/plans/business-icon.png'
  import enterprise from '@/assets/icons/plans/enterprise-icon.png'
  import corporate from '@/assets/icons/plans/corporate-icon.png'
  import startupbg from '@/assets/images/startup-cardbg.png'
  import businessbg from '@/assets/images/business-cardbg.png'
  import enterprisebg from '@/assets/images/enterprise-cardbg.png'
  import corporatebg from '@/assets/images/corporate-cardbg.png'
  import Swal from 'sweetalert2'
  import { currencies } from '@/locales/countries.json'
  export default {
    name: 'PagesPlanCard',

    components: {
      PagesBtn: () => import('./Btn'),
    },
    filters: {
      numberFormat (val) {
        if (val || val === 0) { return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
    },
    props: {
      plan: {
        type: Object,
        default: () => ({
          best: false,
          heading: undefined,
          icon: undefined,
          title: undefined,
          text: undefined,
          cost: undefined,
        }),
      },
    },
    data () {
      return {
        startup,
        business,
        enterprise,
        corporate,
        startupbg,
        businessbg,
        enterprisebg,
        corporatebg,
        loading: false,
      }
    },
    computed: {
      isAuth () {
        return !!this.$store.state.users.user
      },
      profile () {
        return this.$store.getters['users/getProfile']
      },
      currencies () {
        return this.$store.getters['payment/getCurrencies']
      },
      currency () {
        return 'USD'
      },
    },
    mounted () {
      const vm = this
      vm.$store.dispatch('payment/getCurrencies').then(() => vm.getCurrencyValue())
    },
    methods: {
      queuePlan (plan) {
        const vm = this
        // la funcion debe:
        // guardar el plan que escogio el usuario en el storage
        vm.$store.dispatch('subscriptions/selectPlan', plan).then(function () {
          // si el usuario no esta registrado, mandarlo a la pagina de registro
          if (vm.isAuth) {
            // console.log(plan)
            vm.$router.push(
              {
                name: 'Manejador de planes',
                params:
                  {
                    plan: plan,
                  },
              },
            )
            // vm.planes()
          } else {
            vm.$router.replace('/pages/register').catch(err => {
              console.log(err)
            })
          }
        })
        // una vez el usuario se registra, llena los datos, y cierra el modal, se despliega otro modal para seguir con el proceso del plan que escogio
        // si el usuario ya esta registrado, desplegar el modal para seguir el proceso con la pasarela de pago.
      },
      planes () {
        const vm = this
        axios.post('https://api.payulatam.com/payments-api/rest/v4.9/subscriptions/', vm.itemData).then(res => {
          // console.log(res)
        }).catch(e => {
          // console.log(e)
        })
      },
      setDataNotification (icon, text) {
        const vm = this
        vm.loading = false
        Swal.fire(
          text,
          '',
          icon,
        ).then(() => {
          if (icon === 'success') {
            vm.$router.push('/dashboard/profile')
          }
        })
      },
      getCurrencyValue (amount) {
        const vm = this
        let country = 'Colombia'
        if (vm.profile.direction) {
          country = vm.profile.direction.country
        }

        const currencyObj = currencies.find(item => item.country === country)
        const currencyCode = currencyObj ? currencyObj.currency : 'COP'
        const currencyPair = `USD${currencyCode}`

        if (vm.currencies[currencyPair]) {
          return Math.ceil(parseFloat(vm.currencies[currencyPair]) * amount)
        } else {
          return false // Valor por defecto si no se encuentra el par de divisas
        }
      },
      getCurrencyName () {
        const vm = this
        let country = 'Colombia'
        if (vm.profile.direction) {
          country = vm.profile.direction.country
        }
        const currencyObj = currencies.find(item => item.country === country)
        const currencyCode = currencyObj ? currencyObj.currency : 'COP'
        return currencyCode
      },
    },

  }
</script>

<style lang="scss">
  .plan--card {
    position: relative;
    width: 100%;
    max-width: 400px;
    margin: 0;
    border-radius: 50px;
    background: #fff;
    box-shadow: 0 1.5rem 4rem rgba(#000, .15);

    &__heading {
      position: absolute;
      font-weight: 800;
      color: white;
      font-size: 1.8rem;
      width: 100%;
      left: 50%;
      top: 2%;
      transform: translateX(-50%);
    }

    &__subtitle {
      // color: #2cb5bc;
      font-weight: bolder;
    }

    &__container {
      margin: 0;
      top: 0;
      left: 0;
      padding: 0;
      position: absolute;
      text-align: center;
      overflow: hidden;
      width: 100%;
    }
    &__btn {
      background: #2cb5bc !important;
      font-weight: 600;
      font-size: 1.4rem !important;
      border-radius: 10px;
    }

    &__cost {
      font-weight: 900;
      color: #000;
      font-size: 2rem;
      display: block;

      &--aprox {
        font-size: 1.2rem;
      }
    }

    &__description {
      font-weight: 400;
      font-size: 1rem;
      padding: 0 2rem;
      display: block;
      text-align: center;
    }

    &__avatar {
      margin-top: 8.5rem;
      border-radius: 50%;
      font-size: 25px;
      text-align: center;
      margin-right: 10px;
      border-radius: 50%;
      display: inline-block;
      padding: 30px;
      box-sizing: border-box;

      &__img {
        display: block;
        height: 3rem;
        width: 3rem;
      }

      &__startup {
        background: #2cb5bc;
      }

      &__bussiness {
        background: rgb(53,175,189);
        background: linear-gradient(90deg, rgba(53,175,189,1) 0%, rgba(55,161,188,1) 100%);
      }

      &__enterprise {
        background: rgb(70,141,190);
        background: linear-gradient(90deg, rgba(70,141,190,1) 0%, rgba(78,119,190,1) 100%);
      }

      &__corporate {
        background: rgb(85,104,190);
        background: linear-gradient(90deg, rgba(85,104,190,1) 0%, rgba(87,100,190,1) 100%);
      }
    }
  }
</style>
